import { render, staticRenderFns } from "./chatsoptifyglobaldaily.vue?vue&type=template&id=60f887f3"
import script from "./chatsoptifyglobaldaily.vue?vue&type=script&lang=js"
export * from "./chatsoptifyglobaldaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports